/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  SystemVarsAccountsXeroSyncDto,
  XeroSyncInfoDto,
  XeroSyncProgressDto,
} from '@gh/builder-shared-data';

export type XeroSyncDetails = SystemVarsAccountsXeroSyncDto & {
  xeroSyncLastCC?: Date;
  xeroSyncLastJobs?: Date;
  xeroSyncLastContacts?: Date;
  xeroSyncLastInvoices?: Date;
  isXeroConnected: boolean;
  status: XeroSyncStatus;
};

export type XeroSyncStatus = XeroSyncProgressDto;

export const xeroSyncDetailsFromDto = (xero: XeroSyncInfoDto,
                                       status: XeroSyncStatus): XeroSyncDetails => ({
  status,
  isXeroConnected: xero.isAccountingActivated,
  syncCostCenters: false,
  syncContacts: false,
  syncJobNumber: false,
  syncInvoices: false,
  xeroSyncLastCC: xero.xeroSyncLastCC,
  xeroSyncLastContacts: xero.xeroSyncLastContacts,
  xeroSyncLastInvoices: xero.xeroSyncLastInvoices,
  xeroSyncLastJobs: xero.xeroSyncLastJobs,
});

export const xeroSyncDetailsToDto = (details: XeroSyncDetails): SystemVarsAccountsXeroSyncDto => ({
  syncInvoices: details.syncInvoices,
  syncJobNumber: details.syncJobNumber,
  syncContacts: details.syncContacts,
  syncCostCenters: details.syncCostCenters,
});

export const isXeroSyncInProgress = (status: XeroSyncStatus) => status.initialSyncInProgress || status.syncInProgress;
